// 接口定义
import base from './base'

import login from './modules/login'
import dashboard from './modules/dashboard'
import statistics from './modules/statistics'
// import UserPageInfo from './modules/UserPageInfo'
// import PageInfo from './modules/PageInfo' // 页面模板信息统计
// import UserTplInfo from './modules/UserTplInfo' // 用户页面模板信息统计
// import PageTplInfo from './modules/PageTplInfo' // 页面模板信息统计
// import ComponentInfo from './modules/ComponentInfo' // 组件信息统计

export default {
  ...base,
  login,
  dashboard,
  statistics
  // UserPageInfo,
  // PageInfo,
  // UserTplInfo,
  // PageTplInfo,
  // ComponentInfo
}
